import { createFileRoute, redirect } from "@tanstack/react-router";

/** Moved into the settings hub; the address it was bookmarked at still works. */
export const Route = createFileRoute("/_authenticated/_administration/roles")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/roles" });
  },
});
